<template>
  <div class="c--about-us_founder-detail new-container mx-auto">
    <div class="founder-detail-container">
      <div class="founder-detail">
        <div class="founder-detail-item">
          <div class="founder-detail-item-image">
            <img
              :data-src="info.img"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              width="445"
              height="455"
              alt=""
              v-lazy-load
            />
          </div>
          <div class="founder-detail-item-text">
            <h1 class="founder-detail-name">{{ info.name }}</h1>
            <h2 class="founder-detail-title">{{ info.title }}</h2>
            <div class="founder-detail-description" v-html="info.description" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'founder-detail',

    props: {
      info: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .founder-detail {
    display: grid;
    row-gap: 40px;
    margin: 40px 0;

    .founder-detail-item {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: repeat(12, minmax(0, 1fr));
      align-items: flex-start;

      &-image {
        grid-column: span 5 / span 5;
        grid-column-start: 1;

        img {
          max-width: 100%;
          height: auto;
        }
      }

      &-text {
        grid-column: span 6 / span 6;
        grid-column-start: 7;

        .founder-detail-name {
          color: #4a4a4a;
          font-size: 27px;
          font-weight: 600;
          letter-spacing: -0.5px;
          line-height: 32px;
        }
        .founder-detail-title {
          color: #4a4a4a;
          font-size: 21px;
          font-weight: 600;
          letter-spacing: -0.3px;
          line-height: 25px;
        }
        .founder-detail-description {
          color: #8a8a8a;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 21px;
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .founder-detail {
      margin: 30px 0;

      .founder-detail-item {
        grid-auto-flow: row;
        row-gap: 20px;
        grid-template-columns: repeat(1, minmax(0, 1fr));

        &-image,
        &-text {
          grid-column: span 1 / span 1 !important;
          grid-column-start: 1 !important;
        }
        &-image {
          order: 1;
        }
        &-text {
          order: 2;
        }
      }
    }
  }
  @media only screen and (max-width: 567px) {
    .founder-detail {
      margin: 20px 0;

      .founder-detail-item {
        &-text {
          .founder-detail-name {
            font-size: 19px;
          }
          .founder-detail-title {
            font-size: 17px;
          }
        }
      }
    }
  }
</style>
